// Centralized asset imports to prevent multiple loads and improve performance
// Import once, reuse everywhere

// Spotify Assets
import spotifyLogoWhiteImg from "@/assets/spotify-logo-white.png";
import spotifyIconWhiteImg from "@/assets/spotify-icon-white.png";
// 2026-05-09: swapped from .png to .svg — the previous PNG was a UI
// screenshot of a "Spotify" pill button (with text label inside) instead
// of a clean glyph. At 20×20 in the header toggle it rendered as an
// unreadable smudge. SVG is the official Spotify mark (green circle +
// 3 black wave arcs), scales cleanly at every size.
import spotifyIconGreenImg from "@/assets/spotify-icon-green.svg";
import spotifyLogoBlackImg from "@/assets/spotify-logo-black.png";

// YouTube Assets
import youtubeLogoWhiteImg from "@/assets/youtube-logo-white.png";
import youtubeLogoWhiteTrimmedImg from "@/assets/youtube-logo-white-trimmed.png";
import youtubeIconRedImg from "@/assets/youtube-icon-red.png";
import youtubeIconWhiteImg from "@/assets/youtube-icon-white.png";

// Spotivibly Assets
import spotiviblyLogoImg from "@/assets/spotivibly-logo.png";

// Export all assets as a singleton object
export const Assets = {
  spotify: {
    logoWhite: spotifyLogoWhiteImg,
    iconWhite: spotifyIconWhiteImg,
    iconGreen: spotifyIconGreenImg,
    logoBlack: spotifyLogoBlackImg,
  },
  youtube: {
    logoWhite: youtubeLogoWhiteTrimmedImg,
    logoWhitePadded: youtubeLogoWhiteImg,
    iconRed: youtubeIconRedImg,
    iconWhite: youtubeIconWhiteImg,
  },
  spotivibly: {
    logo: spotiviblyLogoImg,
  },
} as const;



